module.exports = __webpack_public_path__ + "static/media/google_g.8337ef21.png";